import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, Redirect } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Row, Col } from 'react-bootstrap';
import { useReactToPrint } from 'react-to-print';

import {
  Container,
  CardOrder,
  MainContainer
} from '~/components/layout/Logistic/styles';
import {
  TitlePage as IconsTop,
  CloseIconStyled as IconStyled,
  Title,
  TextQuantity,
  ButtonDivision,
  LoadingIcon,
  CardInputItem,
  PrintIconStyled,
  ButtonOutline
} from './styles';
import api from '~/services/api';
import close from '~/assets/images/close.png';
import '~/components/styles/Global.css';
import { verifyRoles } from '~/utils/functions/verifyRoles';
import BodyPreviusPix from '~/components/pages/Logistic/BodyPreviusPix';
import { InfoButton } from '~/components/layout/Buttons';
import Loading from '~/components/layout/Loading';
import OpenChatBot from '~/components/layout/Chatbot';
import Stepper from '~/components/layout/Logistic/StepperLine';
import OtherPayment from '~/components/layout/Logistic/OtherPayment';
import PrinterIcon from '~/assets/images/printer.svg';

const maxRequest = 20;

export default function PixPayment() {
  const dispatch = useDispatch();
  const history = useHistory();
  const componentRef = useRef();

  const roles = useSelector(state => state.rolesReducer.roles);
  const logisticPaymentReducer = useSelector(state => state.logisticPaymentReducer);

  const [loadingPage, setLoadingPage] = useState(true);
  const [modal, setModal] = useState(false);
  const [loadingConfirm, setLoadingConfirm] = useState(false);
  const [loadingConfirmOther, setLoadingConfirmOther] = useState(false);
  const [orderDetails, setOrderDetails] = useState(null);
  const [pix, setPix] = useState(null);
  const [requestCount, setRequestCount] = useState(0);

  const makeRequest = () => {

    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem("access_token")
    };
    const parameters = {
      method: 'GET',
      headers: header,
    };
    api.get(`/sales/order/v2/orders-ga/${logisticPaymentReducer?.order?.id}`, parameters)
      .then(response => {
        const { data } = response;

        dispatch({
          type: "SET_BRANCH_CODE",
          code: data.supplyBranchCode
        });

        if ( data.pixKeyStatus !== 'AGUARDANDO PAGAMENTO') {
          if (requestCount < maxRequest) {
            setRequestCount(prevCount => prevCount + 1);
            setTimeout(makeRequest, 2000);
          } else {
            setLoadingPage(false);
          }
        } else {
          setOrderDetails(data);
          getPixDetails();
        }
      })
      .catch(err => {
        const erro = err.response;
        if (erro.status !== 500) {
          const message = err.response.data.message;
          if (message) {
            toast.error(message);
          }
        } else {
          toast.error("Ocorreu um erro interno na aplicação");
        }
      });
  };

  async function getPixDetails() {

    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem("access_token")
    };
    const parameters = {
      method: 'GET',
      headers: header,
    };
    await api.get(`/sales/order/v2/orders-ga/${logisticPaymentReducer.order.id}/pix-keys`, parameters).then((res) => {
      setPix(res.data);
      setLoadingPage(false);
    })
    .catch(err => {
      const erro = err.response;
      if (erro.status !== 500) {
        const message = err.response.data.message;
        if (message) {
          toast.error(message);
        }
        setLoadingPage(false)
      } else {
        toast.error("Ocorreu um erro interno na aplicação");
      }
      setLoadingPage(false)
    });
  }

  useEffect(() => {
    makeRequest();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      var iframes = document.querySelectorAll('iframe');
      for (var i = 0; i < iframes.length; i++) {
        if (iframes[i].id !== 'indecx-iframe') {
          iframes[i].parentNode.removeChild(iframes[i]);
        }
      }
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    var iframes = document.querySelectorAll('iframe');
    for (var i = 0; i < iframes.length; i++) {
      if (iframes[i].id !== 'indecx-iframe') {
        iframes[i].parentNode.removeChild(iframes[i]);
      }
    }
  }, [document]);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const handlePix = () => {
    if (pix) {
      history.push(`/detalhes-do-pedido?id=${orderDetails.id}`);
    } else {
      history.push('/pagamento-a-vista');
    }
  }

  const handleNotPix = () => {
    if (pix) {
      setModal(true);
      setLoadingConfirmOther(true);
    } else {
      history.push(`/detalhes-do-pedido?id=${orderDetails.id}`);
    }
  }

  useEffect(()=>{
    console.log("logisticPaymentReducer", logisticPaymentReducer);
  },[])

  return (
    <Container>
      {verifyRoles(roles, 'STATUS_DO_PEDIDO') ? (
        <>
          <IconsTop>
            <div></div>
            <IconStyled
              src={close}
              alt="Ícone de fechar"
              onClick={() => history.push('/lista-de-pedidos')}
            />
          </IconsTop>
          <OtherPayment
            modal={modal}
            setModal={setModal}
            loadingConfirmOther={loadingConfirmOther}
            setLoadingConfirmOther={setLoadingConfirmOther}
           />
          {loadingPage ? (
            <Loading loadingColor={'white'} />
          ) : (
            <CardOrder ref={componentRef}>
              <MainContainer>
                <Title>
                  <span>Pedido</span>
                  <PrintIconStyled
                    src={PrinterIcon}
                    alt="Ícone de voltar"
                    onClick={handlePrint}
                  />
                </Title>
                <Stepper activeStep={7} steps={7} />
                  <CardInputItem>
                    <Row>
                      <Col>
                        <Row>
                          <TextQuantity>Pedido: {orderDetails?.number ? orderDetails.number : ''}</TextQuantity>
                        </Row>
                      </Col>
                    </Row>
                  </CardInputItem>
                  <BodyPreviusPix
                    order={orderDetails}
                    pixData={pix}
                  />
                <ButtonDivision onClick={() => handlePix()}>
                  <InfoButton style={{ margin: "0.5rem 0 0.5rem 0" }} disabled={loadingConfirm}>
                    {loadingConfirm ? (
                      <LoadingIcon className="fa fa-spinner fa-pulse fa-3x fa-fw" />
                    ) : (
                      <div> { pix ? ' Pagar mais tarde' : 'Enviar comprovante' }</div>
                    )}
                  </InfoButton>
                </ButtonDivision>
                <ButtonDivision onClick={() => handleNotPix()}>
                  <ButtonOutline outline disabled={loadingConfirmOther} style={{ marginBottom: '1rem' }}>
                    {loadingConfirmOther ? (
                      <LoadingIcon className="fa fa-spinner fa-pulse fa-3x fa-fw" />
                    ) : (
                      <div>{ pix ? 'Pagar de outra forma' : 'Pagar mais tarde' }</div>
                    )}
                  </ButtonOutline>
                </ButtonDivision>
              </MainContainer>
              <OpenChatBot backgroundColor={'#00f3ff'} />
            </CardOrder>
          )}
        </>
      ) : (
        <Redirect to="/portal" />
      )}
    </Container>
  );
}
